


































































































































































































































































import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import { Component, Vue } from "vue-property-decorator";
import Pdf from "@/components/Pdf.vue";
import Galery from "@/components/Galery.vue";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Pdf,
    Galery,
    BIcon,
    BIconBoxArrowRight,
    Header,
    Menu,
    NextPrevBtn,
    Footer
  }
})
export default class InterviewKeys extends Vue {
  protected galeryInterview: string[] = [
    "/picture_interview/fundamentals_Interview_What'sit.png",
    "/picture_interview/fundamentals_Interview_Keys.png",
    "/picture_interview/fundamentals_Interview_Question.png",
    "/picture_interview/fundamentals_Interview_Question2.png",
    "/picture_interview/fundamentals_Interview_Grid.png"
  ];
  protected pdfInterview = [
    {
      PdfLink: "/pdf_interview/fundamental_Interview_What'sit.pdf",
      PdfDownload: "Qu'est-ce-qu'un-entretien?",
      TxtPdf: "Fiche 1 : Qu’est-ce qu’un entretien ? "
    },
    {
      PdfLink: "/pdf_interview/fundamentals_Interview_Keys.pdf",
      PdfDownload: "10PointsClésEntretien",
      TxtPdf: "Fiche 2 : Les 10 points clés de l’entretien"
    },
    {
      PdfLink: "/pdf_interview/fundamental_Interview_Question.pdf",
      PdfDownload: "QuestionType1Entretien",
      TxtPdf: "Fiche 3 : Les questions types 1"
    },
    {
      PdfLink: "/pdf_interview/fundamental_Interview_Question2.pdf",
      PdfDownload: "QuestionType2Entretien",
      TxtPdf: "Fiche 4 : Les questions types 2"
    },
    {
      PdfLink: "/pdf_interview/fundamentals_Interview_Grid.pdf",
      PdfDownload: "GrilleAnalyseEntretien",
      TxtPdf: "Fiche 5 : Grille d’analyse recruteur"
    }
  ];

  protected bool1 = false;
  protected bool2 = false;
  protected bool3 = false;
  protected bool4 = false;
  protected bool5 = false;
  protected show1(): void {
    if (this.bool1 == false) this.bool1 = true;
    else this.bool1 = false;
  }
  protected show2(): void {
    if (this.bool2 == false) this.bool2 = true;
    else this.bool2 = false;
  }
  protected show3(): void {
    if (this.bool3 == false) this.bool3 = true;
    else this.bool3 = false;
  }
  protected show4(): void {
    if (this.bool4 == false) this.bool4 = true;
    else this.bool4 = false;
  }
  protected show5(): void {
    if (this.bool5 == false) this.bool5 = true;
    else this.bool5 = false;
  }
  protected nxtprevInterviewKeys = {
    BoolPrev: false,
    BoolNext: true,
    PrevImage: "",
    NextImage: "/thumbnail6.png",
    PrevLink: "",
    NextLink: "/Entretien/Astuces"
  };
}
